











import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import PortalAnnouncementsSkeltonLoader from '@/components/atoms/skelton/PortalAnnouncementsSkeltonLoader.vue';
import PortalAnnouncementsPanel from '@/components/organisms/PortalAnnouncementsPanel.vue';
import {
  UserAnnouncement,
  UpdateUserAnnouncementQueryParam,
} from '@/types/type';

@Component({
  components: { PortalAnnouncementsSkeltonLoader, PortalAnnouncementsPanel },
})
export default class PortalAnnouncements extends Vue {
  @Prop()
  private loading!: boolean;

  @Prop()
  private userAnnouncements!: UserAnnouncement[];

  @Emit('button-link-opened')
  private buttonLinkOpened(
    param: UpdateUserAnnouncementQueryParam
  ): UpdateUserAnnouncementQueryParam {
    return param;
  }
}
